<template>
<div class="product-bom-plugin">
  <Row :gutter="16" v-if="boms.length === 0" style="margin-bottom: 10px;">
    <Col span="12">
      <Select v-model="selectedBomId" filterable
        clearable transfer
          :loading="loading" :placeholder="$t('product.plugins.bom.search_placeholder')"
                :remote-method="handleSearchBomAssociation" >
        <Option v-for="bomOption in bomAssociationMatches" :value="bomOption.id" :key="bomOption.id">
          <span v-if="bomOption.part">[{{ bomOption.part.part_number }}] </span> {{bomOption.name}}  Ver:{{ bomOption.version }}
        </Option>
      </Select>
    </Col>
    <Col span="12">
      <Button :disabled="!selectedBomId && boms.length === 0" type="primary" @click="handleAddBomAssociation">{{ $t('associate') }}</Button>
    </Col>
  </Row>
  <div class="clear">
    <Table row-key="id" :data="boms" :columns="columns">
        <template slot-scope="{ row, column, index }" slot="propsCell">
          {{_.get(row, column.key)}}
        </template>
        <template slot-scope="{ row, column, index }" slot="name">
          {{ row.name }}
          <Badge color="red" v-show="row.is_draft" :text="$t('product.plugins.bom.found_new_changes')" />
        </template>
        <template slot-scope="{ row, column, index }" slot="versionCell">
          <span>{{ row.version ? row.version : 'N/A' }}</span>
        </template>
        <template slot-scope="{ row, column, index }" slot="actionCell">
          <router-link :to="bomViewRoute(row)" target="_blank">
            <Button type="text" size="small" icon="md-create"></Button>
          </router-link>
          <Poptip transfer
            confirm
            title="Are you sure you want to remove this BOM association?"
            @on-ok="handleRemoveBomAssociation(row)">
            <Button type="text" style="margin-left:5px;" v-show="canRemoveBomAssociation(row)" size="small" icon="ios-trash"></Button>
          </Poptip>
        </template>
    </Table>
  </div>
</div>

</template>

<script>
import { mapActions } from 'vuex'
import FieldsDef from './plugin-data'

export default {
  name: 'ProductBomPlugin',
  props: {
    productId: {
      required: true
    }
  },
  data() {
    return {
      bomRootMaps: {},
      boms: [],
      loading: false,
      bomAssociationMatches: [],
      selectedBomId: null,
      columns: FieldsDef.bomPlugin.columns
    }
  },
  watch: {
    productId: function () {
      this.handleLoadAssociatedBom()
    }
  },
  mounted () {
    this.handleLoadAssociatedBom()
  },
  methods: {
    ...mapActions([
      'getProductReferencePluginData',
      'searchProductAssociatedBom',
      'addProductAssociatedBom',
      'removeProductAssociatedBom'
    ]),
    handleRemoveBomAssociation (bom) {
      this.removeProductAssociatedBom({ id: this.productId, bom_id: bom.id }).then((res) => {
        this.handleLoadAssociatedBom()
      })
    },
    handleSearchBomAssociation (keyword) {
      this.loading = true
      this.searchProductAssociatedBom({ id: this.productId, keyword: keyword }).then(res => {
        this.bomAssociationMatches = res.data
      }).finally(() => {
        this.loading = false
      })
    },
    canRemoveBomAssociation (bom) {
      return _.toInteger(bom.product_id) === _.toInteger(this.productId)
    },
    handleLoadAssociatedBom() {
      this.loading = true
      this.getProductReferencePluginData({ plugin: 'bom', productId: this.productId }).then(resp => {
        this.boms = resp.data
        _.forEach(this.boms, (child) => {
          this.handleBomSetRootMapping(child)
        })
      }).finally(() => {
        this.loading = false
      })
    },
    handleAddBomAssociation () {
      this.loading = true
      this.addProductAssociatedBom({ id: this.productId, bom_id: this.selectedBomId }).then(res => {
        this.handleLoadAssociatedBom()
      })
    },
    handleBomSetRootMapping(bom, rootBomId = null) {
      if (!rootBomId) {
        rootBomId = bom.id
      }
      this.bomRootMaps[bom.id] = rootBomId
      if (bom.children && bom.children.length > 0) {
        _.forEach(bom.children, (child) => {
          this.handleBomSetRootMapping(child, rootBomId)
        })
      }
    },
    bomViewRoute (bom) {
      let route = { name: 'menu.bom.view', params: { bomId: bom.id } }
      if (bom.version) {
        route['query'] = {
          version: bom.version
        }
      }
      return route
    }
  }
}
</script>

<style lang="less">
.product-bom-plugin .ivu-badge-status-text {
  font-size: 90%;
  color: #c9c9c9;
}
</style>
